import {GET, POST, DELETE, SERVER_URL} from '../constants/API_CONSTANTS';
import {request} from '../utils/request';

export const createPriceAdjustmentApi = async (data) => {
  return request(POST, `${SERVER_URL}/menu/price-adjustments/create`, {data});
};

export const getAllPriceAdjustmentsApi = async () => {
  return request(GET, `${SERVER_URL}/menu/price-adjustments/all`);
};

export const deletePriceAdjustmentApi = async (id) => {
  return request(DELETE, `${SERVER_URL}/menu/price-adjustments/${id}`);
};

export const resetAllPriceAdjustmentsApi = async () => {
  return request(DELETE, `${SERVER_URL}/menu/price-adjustments/reset`);
};

export const calculatePriceAdjustmentsApi = async (data) => {
  return request(POST, `${SERVER_URL}/menu/price-adjustments/calculate`, {
    data
  });
};
